import { colors } from 'component-library/styles/colors';
import React, { FC, SVGProps } from 'react';

export const Checkmark: FC<SVGProps<SVGSVGElement>> = (props) => (
  <svg
    width="22"
    height="24"
    viewBox="0 0 22 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.74 23.1L5.01 22.8L5.25 22.65L5.52 22.8C5.91 22.5 6.24 22.17 6.51 21.84C6.78 21.51 7.29 20.64 8.1 19.29L9.96 16.14C10.95 14.46 16.14 7.41 17.31 6.09C20.01 3 20.91 2.07 21.27 1.59C21.6 1.17 21.81 0.84 21.81 0.599999C21.81 0.45 21.72 0.209999 21.57 0.209999C21.42 0.209999 21.18 0.329999 20.88 0.54L21.12 0L20.1 0.599999L20.16 0.179999C20.1 0.359999 19.62 0.84 19.5 0.84C19.41 0.84 19.38 0.749999 19.38 0.599999V0.479999L18.54 0.899999C18.48 0.899999 18.42 0.87 18.42 0.779999C18.42 0.69 18.48 0.479999 18.54 0.179999C18.12 0.629999 17.52 1.14 16.74 1.68C15.69 2.4 11.61 7.53 9.96 10.2C8.85 11.97 8.4 13.02 8.22 13.02C8.16 13.02 8.13 12.9 8.1 12.66C7.56 13.89 7.08 14.91 6.6 15.66C6.12 16.41 5.67 16.8 5.34 16.8C4.95 16.8 4.62 16.05 4.26 14.52C4.11 13.86 3.78 13.44 3.3 13.2L3.21 13.17C3.12 13.17 3 13.23 2.85 13.32C2.7 13.41 2.61 13.5 2.55 13.5H2.52L1.98 13.32L1.5 14.04C1.44 14.13 1.32 14.16 1.23 14.16C1.08 14.16 0.96 14.13 0.9 14.04C0.78 14.46 0.63 14.67 0.51 14.67C0.42 14.67 0.24 14.61 0 14.46C0.21 16.05 0.39 17.1 0.57 17.61C0.93 18.6 1.74 20.85 2.52 22.35C2.61 22.53 2.73 22.74 2.82 22.92C3.12 22.74 3.21 22.71 3.42 22.71L3.66 22.74C3.81 22.8 3.9 22.89 3.9 23.04L4.59 22.71C4.71 22.71 4.74 22.83 4.74 23.1Z"
      fill={colors.navyBlue}
    />
  </svg>
);
